import { useAuth } from "../../contexts/auth.context";

import React, { useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { useNavigate } from "react-router-dom";

interface YourAnswerProps {
    onAnswerSubmit: (answer: string) => void;
}

const YourAnswer: React.FC<YourAnswerProps> = ({ onAnswerSubmit }) => {
    const navigate = useNavigate();
    const { user } = useAuth();
    const signedIn = user.id !== -1;
    const [error, setError] = useState<boolean>(false);
    const [hideControls, setHideControls] = useState<boolean>(true);

    function handleFormSubmit(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault();
        const form = event.currentTarget;
        const formData = new FormData(form);
        const body = formData.get("your-answer") as string;
        //console.log(body);
        if (!body) {
            setError(true);
            return;
        }
        onAnswerSubmit(body);
        form.reset();
    }

    function handleFormReset() {
        setHideControls(true);
        setError(false);
    }

    function handleFormClick(event: React.MouseEvent<HTMLDivElement, MouseEvent>) {
        event.preventDefault();
        if (!signedIn) {
            navigate("/signin");
            return;
        }
        setHideControls(false);
    }

    const formControl = (
        <>
            <Button type="reset">Cancel</Button>
            <Button type="submit">Post</Button>
        </>
    );

    return (
        <Card sx={{ display: "grid" }}>
            <CardContent
                component="form"
                noValidate
                autoComplete="off"
                onSubmit={handleFormSubmit}
                onReset={handleFormReset}
            >
                <TextField
                    id="your-answer"
                    name="your-answer"
                    label="Add an answer"
                    multiline
                    error={error}
                    helperText={error ? "Answer cannot be empty" : ""}
                    margin="dense"
                    fullWidth
                    sx={{
                        ".MuiInputBase-input": { fontSize: "large" },
                    }}
                    onChange={() => setError(false)}
                    onClick={handleFormClick}
                />
                {hideControls ? null : formControl}
            </CardContent>
        </Card>
    );
};

export default YourAnswer;
